import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { EMAIL_REG_EXP, PHONE_REG_EXP } from 'common/constants'

import SignInFormComponent from 'components/SignInForm/SignInForm'

@inject(stores => {
  const { AuthStore } = stores?.rootStore
  return {
    AuthStore,
  }
})
@observer
class SingIn extends Component {
  onSubmit = ({ emailOrPhone }) => {
    const {
      AuthStore: { onSingIn },
    } = this.props

    const params = {}

    if (emailOrPhone.match(PHONE_REG_EXP)) {
      params.phone =
        emailOrPhone[0] === '+' ? emailOrPhone : `+1${emailOrPhone}`
    } else {
      params.email = emailOrPhone
    }

    onSingIn(params)
  }

  render() {
    const { onSubmit, props } = this
    const {
      AuthStore: { state },
    } = props

    return <SignInFormComponent onSubmit={onSubmit} state={state.ui} />
  }
}

export default SingIn
